import type { FaireProductEntity } from "../../entity_types/product";

export const p_edeevnkp7s: FaireProductEntity = {
  token: "p_edeevnkp7s",
  type: "product",
  name: "Puzzle Pieces Jigsaw Colorful Pattern Socks from the Sock Pa",
  brandToken: "b_hshp7p463w",
  brandName: "Sock Panda",
  imageUrl:
    "https://cdn.faire.com/fastly/8157bc940cbc0ab1a0f4f4ed967b2be309294d6624cde945e042db117e54f06d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/94b25d4ae9b91c406919d0a19d270180601c96a5789c1112625e742e6f40fc16.jpeg",
    "https://cdn.faire.com/fastly/079eed001d2460818130703202c056c2e89b1095f7bd1e17d8e0a7f0899588de.jpeg",
    "https://cdn.faire.com/fastly/8780fe0b87c032e1166542c25918ad7a4c5de5c43e5736fd1e75ba297432529f.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "• Sock Size 10-13 (Adult Large), 9-11 (Adult Medium) or 6-8 (Adult Small)\n• Men, Women and Teens! Shoe sizes 8-12, 5-10 or 2-5\n\nColorful jigsaw puzzle pieces make up the cool pattern on this pair of socks. Fantastic!\n\n• 85% Peruvian Cotton, 10% Nylon, 5% Spandex\n• Attention getting design - Guaranteed to start a conversation\n• Up your Sock Game with these fun socks!\n• High quality fabric that will not rip or tear - Very Comfortable.\n• Best if washed in cold water\n• With your purchase, the Sock Panda donates socks to someone in need.\n\nThank you!",
  tags: [],
  msrpDollars: 9,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:24.487Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
